/**
 * Favorites + Recently-Viewed API client.
 * Backend: backend/favorites/router.py (Phase 16.X.1)
 */

const API = import.meta.env.VITE_API_URL ?? '';

async function request(url, token, options = {}) {
  const res = await fetch(`${API}${url}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  });
  if (!res.ok) throw new Error(`API ${res.status}`);
  return res.json();
}

export function toggleFavorite(token, entityType, entityId) {
  return request('/api/v1/aif/favorites/toggle', token, {
    method: 'POST',
    body: JSON.stringify({ entity_type: entityType, entity_id: entityId }),
  });
}

export function listFavorites(token, entityType = null) {
  const qs = entityType ? `?entity_type=${entityType}` : '';
  return request(`/api/v1/aif/favorites/list${qs}`, token);
}

export function trackRecentlyViewed(token, entityType, entityId) {
  return request('/api/v1/aif/favorites/recently-viewed/track', token, {
    method: 'POST',
    body: JSON.stringify({ entity_type: entityType, entity_id: entityId }),
  });
}

export function listRecentlyViewed(token, entityType, limit = 10) {
  return request(
    `/api/v1/aif/favorites/recently-viewed/list?entity_type=${entityType}&limit=${limit}`,
    token,
  );
}
